import getConfig from '@ringcentral/rwc-utils/src/config';

const PASConf = getConfig('PAS');
// backup for cached appConfig
export const initialEndpoint = (PASConf.discoveryInitialEndpoint ||
    PASConf.discoveryInitalEndpoint) as string;
export const server = PASConf.discoveryServer as string;

export default {
    initialEndpoint,
    server,
};
